import React from 'react';
import PropTypes from 'prop-types';
import ProjectHeroWrapper from './project-hero-wrapper';
import ProjectHeroWipe from './project-hero-wipe';
import ProjectButton from '../project-button';
import ProjectBreadcrumb from './project-breadcrumb';
import ProjectLogo from './project-logo';
import ProjectHeadline from './project-headline';
import ProjectHeroImage from './project-hero-image';
import styles from './project-hero.module.css';
import ScrollDown from '../../scroll-down';
import { detectSection } from '../../../utils/helper-functions';

const ProjectHero = ({
  title,
  slug,
  headline,
  featuredImage,
  featuredMobileImage,
  buttonColor,
  buttonColorHover,
  currentPage,
  browserDetect,
  headerHeight,
  mappedIndex,
  currentSectionIndex,
}) => {
  const projectHeroDetect = detectSection(mappedIndex, currentSectionIndex);

  return (
    <ProjectHeroWrapper
      browserDetect={browserDetect}
      headerHeight={headerHeight}
    >
      <ProjectHeroWipe isHome={projectHeroDetect.home()} />
      <div className={styles.container}>
        <div className={styles.content}>
          <ProjectBreadcrumb
            preTitle={'our-work'}
            title={title}
            isHome={projectHeroDetect.home()}
            returnSection={projectHeroDetect.section()}
          />
          <ProjectLogo
            slug={slug}
            isHome={projectHeroDetect.home()}
            returnSection={projectHeroDetect.section()}
          />
          <ProjectHeadline
            headline={headline}
            isHome={projectHeroDetect.home()}
            returnSection={projectHeroDetect.section()}
          />
          <ProjectButton
            currentPage={currentPage}
            buttonColor={buttonColor}
            buttonColorHover={buttonColorHover}
            linkPath={slug}
            isHome={projectHeroDetect.home()}
            returnSection={projectHeroDetect.section()}
          />
        </div>
      </div>
      {currentPage === 'ProjectTemplate' && <ScrollDown color="white" />}
      <ProjectHeroImage
        featuredImage={featuredImage}
        featuredMobileImage={featuredMobileImage}
        browserDetect={browserDetect}
        alt={title}
        isHome={projectHeroDetect.home()}
        returnSection={projectHeroDetect.section()}
      />
    </ProjectHeroWrapper>
  );
};

ProjectHero.propTypes = {
  title: PropTypes.string,
  slug: PropTypes.string,
  headline: PropTypes.string,
  featuredImage: PropTypes.object,
  buttonColor: PropTypes.string,
  buttonColorHover: PropTypes.string,
  currentPage: PropTypes.string,
  browserDetect: PropTypes.string,
  headerHeight: PropTypes.number,
  mappedIndex: PropTypes.number,
  currentSectionIndex: PropTypes.number,
};

export default ProjectHero;



// WEBPACK FOOTER //
// ./src/components/project/project-hero/index.js